import { defineMessages } from "react-intl";

const messages = defineMessages({
  clear: {
    id: "resources.list.filters.clear",
    defaultMessage: "Clear",
    description: "Clear option in filter component",
  },
  delete: {
    id: "resources.list.tools.bulk.delete",
    defaultMessage: "Delete{isTrash, select, true { Forever} other {}}",
    description: "Bulk delete resources button",
  },
  deleteConfirm: {
    id: "resources.list.tools.bulk.delete.confirm",
    defaultMessage:
      "Are you sure you want to {isTrash, select, true {permanently delete {multi, select, true {these files} other {this file}}} other {send {multi, select, true {these files} other {this file}} to trash}}?",
    description: "Bulk delete resources confirmation",
  },
  myFiles: {
    id: "resources.list.filters.myFiles",
    defaultMessage: "My Files",
    description: "My files filter",
  },
  owner: {
    id: "resources.list.filters.owner",
    defaultMessage: "Owner",
    description: "Owner filter",
  },
  resourceShareSuccess: {
    id: "resources.list.tools.share.success",
    defaultMessage:
      "{resourceCount, plural, one {Resource} other {Resources}} shared with {count, plural, one {{userName}} other {{count} people}}",
    description: "Resource shared success notification",
  },
  resourceType: {
    id: "resources.list.filters.resourceType",
    defaultMessage: "Resource Type",
    description: "Resource Type filter",
  },
  restore: {
    id: "resources.list.tools.bulk.restore",
    defaultMessage: "Restore",
    description: "Bulk restore button",
  },
  restoreSuccess: {
    id: "resources.list.tools.bulk.restore.success",
    defaultMessage: "{count, plural, one {Resource} other {Resources}} restored to All Resources",
    description: "Restore success notification",
  },
  search: {
    id: "resources.list.filters.search",
    defaultMessage: "Search",
    description: "Search placeholder",
  },
  share: {
    id: "resources.list.tools.bulk.share",
    defaultMessage: "Share",
    description: "Bulk Share resources button",
  },
  sharedWithMe: {
    id: "resources.list.filters.sharedWithMe",
    defaultMessage: "Shared With Me",
    description: "Shared with me filter",
  },
  shareTitle: {
    id: "resources.toolbar.bulk.share.title",
    defaultMessage: "Share {count, plural, one {resource} other {{count} resources}}",
    description: "Share resources modal title",
  },
});

export default messages;
